import { isIP } from 'is-ip';

export const validateIp = (ip: string): boolean => {
  if (!isIP(ip)) {
    return false;
  }
  return true;
}